export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_CALCULATE_DER';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_CALCULATE_DER';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_CALCULATE_DER';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
